import { useContext } from 'react';

import queryString from 'query-string';

import { getUniqueParams } from '../../../utils/content/getUniqueParams';
import { ContentContext } from '../../context/ContentContext';

export const useSettingsParams = (): string => {
  const { activeItems, defaultItems } = useContext(ContentContext);

  // no need to add a default param to the query string
  const uniqueParams = getUniqueParams(activeItems, defaultItems);

  const query = queryString.stringify(uniqueParams);

  return query ? `?${query}` : '';
};
